function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0L12 2V12H0V2L2 0H10ZM0.912667 2.91267V11.0873H11.0873V2.91267H8.05267C7.702 3.698 6.914 4.246 6 4.246C5.08667 4.246 4.298 3.698 3.948 2.91267H0.912667ZM2.37867 0.912667H9.622L10.7087 2H7.33333C7.33333 2.73667 6.73667 3.33333 6 3.33333C5.264 3.33333 4.66667 2.73667 4.66667 2H1.29133L2.37867 0.912667ZM6.50007 8.43998L7.29273 7.64665C7.48807 7.45132 7.80473 7.45132 8.00007 7.64665C8.1954 7.84198 8.1954 8.15865 8.00007 8.35398L6.35407 9.99998C6.15873 10.1953 5.84207 10.1953 5.64673 9.99998L4.00007 8.35398C3.80473 8.15865 3.80473 7.84198 4.00007 7.64665C4.1954 7.45132 4.51207 7.45132 4.7074 7.64665L5.50007 8.43932V5.8334C5.50007 5.5574 5.72407 5.3334 6.00007 5.3334C6.27607 5.3334 6.50007 5.5574 6.50007 5.8334V8.43998Z",
  fill: "currentColor"
});

function SvgIconArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/iconArchive.e15c6e61.svg";
export { ForwardRef as ReactComponent };